var alignment_rtlignore_default = {
  "alignLeft": "Grjgf",
  "textWrapNowrap": "yQTa0",
  "alignRight": "ulNEM",
  "alignCenter": "lqjVi",
  "sizeFullWidth": "tRtAe",
  "renderedInTable": "PXba3",
  "sizeOriginal": "KMiLJ",
  "sizeContent": "_47AXw",
  "sizeSmall": "HgXLi",
  "sizeSmallCenter": "XAfvq",
  "flex": "dInDh",
  "LEFT": "_9Uq-k",
  "CENTER": "_4a86Y",
  "RIGHT": "UeSPI",
  "AUTO": "qa7RH",
  "JUSTIFY": "ZwJA-"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
